<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t('translationList'))"
      icon="mdi-translate"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t('new')"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('translationOrder')"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="translationListColumnPlugins"
        v-column-drag="translationListColumnPlugins"
        v-column-pin="translationListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                class="pl-action-cell__btn" icon x-small
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="print(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                link
                @click="translatorPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('translationTranslatorPrint')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/translation/order/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row"><a @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a></span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.price.totalCost="{ item }">
          {{ $numberFormat((item.price ? item.price.totalCost : 0)) }}
        </template>
        <template v-slot:item.price.basePriceTotal="{ item }">
          {{ $numberFormat((item.price ? item.price.basePriceTotal : 0)) }}
        </template>
        <template v-slot:item.price.addDocumentPriceTotal="{ item }">
          {{ $numberFormat((item.price ? item.price.addDocumentPriceTotal : 0)) }}
        </template>
        <template v-slot:item.price.specialTranslatTotal="{ item }">
          {{ $numberFormat((item.price ? item.price.specialTranslatTotal : 0)) }}
        </template>
        <template v-slot:item.price.specialTranslatAddPriceTotal="{ item }">
          {{ $numberFormat((item.price ? item.price.specialTranslatAddPriceTotal : 0)) }}
        </template>
        <template v-slot:item.price.urgentAmount="{ item }">
          {{ $numberFormat((item.price ? item.price.urgentAmount : 0)) }}
        </template>
        <template v-slot:item.price.stampTranslatorPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.stampTranslatorPrice : 0)) }}
        </template>
        <template v-slot:item.price.judicialApprovalPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.judicialApprovalPrice : 0)) }}
        </template>
        <template v-slot:item.price.officeServicesPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.officeServicesPrice : 0)) }}
        </template>
        <template v-slot:item.price.equalOriginalPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.equalOriginalPrice : 0)) }}
        </template>
        <template v-slot:item.price.foreignApprovalPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.foreignApprovalPrice : 0)) }}
        </template>
        <template v-slot:item.price.verificationServicesPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.verificationServicesPrice : 0)) }}
        </template>
        <template v-slot:item.price.embassyPrice="{ item }">
          {{ $numberFormat((item.price ? item.price.embassyPrice : 0)) }}
        </template>
        <template v-slot:item.price.discountService="{ item }">
          {{ $numberFormat((item.price ? item.price.discountService : 0)) }}
        </template>
        <template v-slot:item.price.discountTranslate="{ item }">
          {{ $numberFormat((item.price ? item.price.discountTranslate : 0)) }}
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="openComponent('accountingPrint', item.doc_head_id)"
          >
            {{ item.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.customer.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.customer_id)"
            >
              {{ item.customer.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.customer.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.translator.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.translator.id)"
            >
              {{ item.translator.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.translator.fin_id)"
                >
                  <v-icon
                    color="teal"
                    style="font-size: 22px"
                  >
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('turnover') }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.payed.amount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.amount : 0)) }} {{ item.currency.symbol }}
          <v-chip
            v-if="item.payed"
            class="mx-0"
            :color="(parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? 'red' : 'green')"
            small
            outlined
          >
            {{ (parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.price.price)-parseFloat(item.payed.amount)) : $t('payed')) }}
          </v-chip>
        </template>
        <template v-slot:item.payed.paymentsAmount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.paymentsAmount : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.payed.checksAmount="{ item }">
          {{ $numberFormat((item.payed ? item.payed.checksAmount : 0)) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.pre_invoice="{ item }">
          <v-icon
            v-if="item.pre_invoice == 'active'"
            color="green"
          >
            mdi-check
          </v-icon>
        </template>
        <template v-slot:item.tax="{ item }">
          {{ $numberFormat((item.tax ? item.tax : 0)) }}
        </template>
        <template v-slot:item.discount="{ item }">
          {{ $numberFormat((item.discount ? item.discount : 0)) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.number="{ item }">
          <a @click="edit(item)">
            {{ item.number }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.content="{ item }">
          {{ (item.content ? item.content : '') }}
          <div class="pt-1">
            <v-chip
              v-for="(integrate, index) in item.integrator"
              :key="index"
              color="green"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ $t('registerBy') }} : {{ $t(integrate.key) }}  | {{ $t('id') }} : {{ integrate.value }}
                {{ (integrate.number ? ' | ' + $t('number') + ':' + integrate.number : '' ) }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.entrepot.id="{ item }">
          <v-btn
            v-if="item.entrepot"
            :loading="loading"
            class="ma-0 pa-1"
            :color="(item.entrepot.type === 'remittance' ? 'pink' : (item.entrepot.type === 'receipt' ? 'teal' : 'blue'))"
            plain
            small
            @click="entrepot_(item.entrepot)"
          >
            {{ $t(item.entrepot.type) }} {{ $t('entrepot') }} {{ item.entrepot.entrepot.name }} : {{ item.entrepot.id }}
          </v-btn>
        </template>
        <template v-slot:item.plan="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.plan"
              color="primary"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ item.plan.plan.name }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.status.name="{ item }">
          <v-chip
            v-if="item.status && item.status.status"
            :color="item.status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="isMobile ? 6 : Number(showHeaders.length) - 3"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="isMobile ? 6 : 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('price') + ':' : '') }} {{ $numberFormat(totals.price) }}
            </td>
            <td
              :colspan="isMobile ? 6 : 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('discount') + ':' : '') }} {{ $numberFormat(totals.discount) }}
            </td>
            <td
              :colspan="isMobile ? 6 : 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('tax') +':': '') }}  {{ $numberFormat(totals.tax) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sum") }}</span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("price") }}</span>
              <span class="app-list-page-totals__val">{{ $numberFormat(totals.price) }}</span>
            </span>
            <span class="app-list-page-totals__item">
              <span class="app-list-page-totals__key">{{ $t("discount") }}</span>
              <span class="app-list-page-totals__val">{{ $numberFormat(totals.discount) }}</span>
            </span>
            <span class="app-list-page-totals__item app-list-page-totals__item--final">
              <span class="app-list-page-totals__key">{{ $t("tax") }}</span>
              <span class="app-list-page-totals__val">{{ $numberFormat(totals.tax) }}</span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="options.page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t('translationList'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t('new')"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('translationOrder')"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('translationList'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="invoicePrintDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
          <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("translationListFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("translationFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="account"
                :title="$t('customer')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <status
                v-model="translationStatus"
                :hideconfig="true"
              />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <tag v-model="tag" />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('date')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <money
                v-model="fromAmount"
                :dense="true"
                :label="$t('from') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
              <money
                v-model="toAmount"
                :dense="true"
                :label="$t('until') + ' ' + $t('amount')"
                :outlined="true"
                :solo="false"
                :clearable="true"
                value-when-is-empty=""
                :options="options"
                class="dense"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-numeric</v-icon>
              {{ $t("accFilterNumberAmount") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <v-text-field
                v-model="fromNumber"
                :label="$t('from') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-text-field
                v-model="toNumber"
                :label="$t('until') + ' ' + $t('number')"
                outlined
                dense
                clearable
                hide-details
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'TranslationList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Invoicprint,
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId'],
    data: () => ({
      selected: [],
      pageCount: 1,
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      dialogData: null,
      translationStatus: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      showSelect: false,
      filter: false,
      productStatus: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      excelItems: [],
    }),
    computed: {

      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var defs = [
          ['account', app.$t('customer')],
          ['translationStatus', app.$t('status')],
          ['currencyFilter', app.$t('currency')],
          ['fromAmount', app.$t('from') + ' ' + app.$t('amount')],
          ['toAmount', app.$t('until') + ' ' + app.$t('amount')],
          ['fromNumber', app.$t('from') + ' ' + app.$t('number')],
          ['toNumber', app.$t('until') + ' ' + app.$t('number')],
          ['fromDate', app.$t('from') + ' ' + app.$t('date')],
          ['toDate', app.$t('until') + ' ' + app.$t('date')],
          ['tag', app.$t('tag')],
        ]
        return defs
          .filter(function (d) { return has(app[d[0]]) })
          .map(function (d) {
            return { key: d[0], label: d[1], value: show(app[d[0]]) }
          })
      },
      proListKey () {
        return this.translationListColumnPersistKey
      },
      proListLocked () {
        return this.translationListLockedColumns
      },
      translationListColumnPersistKey () {
        return 'translation-order-list-columns'
      },
      translationListLockedColumns () {
        var locked = ['actions', 'id']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      translationListColumnPlugins () {
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
          : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.translationListLockedColumns,
          anchor: 'id',
          minWidth: 60,
          persistKey: this.translationListColumnPersistKey,
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        var app = this
        app.excelItems = []
        const totals = this.items.reduce((acc, d) => {
          acc.price += parseFloat((d.price && d.price.totalCost) || 0) || 0
          acc.discount += parseFloat(d.discount || 0) || 0
          acc.tax += parseFloat(d.tax || 0) || 0
          app.excelItems.push({
            type: app.$t(d.type),
            number: d.number,
            customer: d.customer ? d.customer.name : '',
            date: d.date,
            price: app.$numberFormat((d.price ? d.price.totalCost : 0)),
            payment: (d.payed ? app.$numberFormat(d.payed.amount) : ''),
            user: (d.user ? d.user.name : ''),
          })
          return acc
        }, {
          price: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      this.type = 'translation'
      this.headers = [
        {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'translation_Invoice_header.id',
          width: 30,
        },
        {
          text: this.$t('number'),
          sortable: true,
          value: 'number',
          table: 'translation_Invoice_header.id',
          width: 50,
        },
        {
          text: this.$t('number') + ' ' + this.$t('document'),
          sortable: false,
          value: 'doc_header.number',
          width: 50,
        },
        {
          text: this.$t('customer-name'),
          sortable: false,
          value: 'customer.name',
          width: 150,
        },
        {
          text: this.$t('translator'),
          sortable: false,
          value: 'translator.name',
          width: 150,
        },
        {
          text: this.$t('date'),
          sortable: false,
          value: 'date',
          width: 50,
        },
        {
          text: this.$t('deliveryDate'),
          sortable: false,
          value: 'delivery_date',
          width: 50,
        },
        {
          text: this.$t('sum-total'),
          sortable: false,
          value: 'price.totalCost',
        },
        {
          text: this.$t('status'),
          sortable: false,
          value: 'status.name',
          width: 50,
        },
        {
          text: this.$t('tag'),
          sortable: false,
          value: 'tags',
        },
        {
          text: this.$t('baseTranslate'),
          sortable: false,
          value: 'price.basePriceTotal',
        },
        {
          text: this.$t('addDocument'),
          sortable: false,
          value: 'price.addDocumentPriceTotal',
        },
        {
          text: this.$t('specialTranslat'),
          sortable: false,
          value: 'price.specialTranslatTotal',
        },
        {
          text: this.$t('specialTranslatAdditional'),
          sortable: false,
          value: 'price.specialTranslatAddPriceTotal',
        },
        {
          text: this.$t('urgentAmount'),
          sortable: false,
          value: 'price.urgentAmount',
        },
        {
          text: this.$t('stampTranslator'),
          sortable: false,
          value: 'price.stampTranslatorPrice',
        },
        {
          text: this.$t('judicialApproval'),
          sortable: false,
          value: 'price.judicialApprovalPrice',
        },
        {
          text: this.$t('officeServices'),
          sortable: false,
          value: 'price.officeServicesPrice',
        },
        {
          text: this.$t('equalOriginal'),
          sortable: false,
          value: 'price.equalOriginalPrice',
        },
        {
          text: this.$t('foreignApproval'),
          sortable: false,
          value: 'price.foreignApprovalPrice',
        },
        {
          text: this.$t('verificationServices'),
          sortable: false,
          value: 'price.verificationServicesPrice',
        },
        {
          text: this.$t('embassy'),
          sortable: false,
          value: 'price.embassyPrice',
        },
        {
          text: this.$t('discountService'),
          sortable: false,
          value: 'price.discountService',
        },
        {
          text: this.$t('discountTranslate'),
          sortable: false,
          value: 'price.discountTranslate',
        },
        {
          text: this.$t('sumPayments'),
          sortable: false,
          value: 'payed.paymentsAmount',
        },
        {
          text: this.$t('sumChecks'),
          sortable: false,
          value: 'payed.checksAmount',
        },
        {
          text: this.$t('sumPayed'),
          sortable: false,
          value: 'payed.amount',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.translationListLockedColumns,
        anchor: 'id',
      })
      this.loadTranslationListColumnSettings()
    },
    mounted () {
      // this.getItems()
    },
    methods: {

      resetFilters () {
        var app = this
        ;[
          'account', 'translationStatus', 'currencyFilter',
          'fromAmount', 'toAmount', 'fromNumber', 'toNumber',
          'fromDate', 'toDate', 'tag',
        ].forEach(function (k) { app[k] = null })
      },
      loadTranslationListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.translationListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.translationListLockedColumns,
            anchor: 'id',
          })
          app.$forceUpdate()
        })
      },
      entrepot_ (item) {
        this.$router.push({ name: item.type + 'Edit', params: { id: item.id } })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'translationOrderEdit', params: { id: item.uid } })
      },
      print (item) {
        this.$router.push({ name: 'translationPrint', params: { id: item.uid } })
      },
      translatorPrint (item) {
        this.$router.push({ name: 'translationTranslatorPrint', params: { id: item.uid } })
      },
      entrepotPrint (item) {
        this.$router.push({ name: item.entrepot.type + 'Print', params: { id: item.entrepot.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'translation', {
          params: {
            search: app.search,
            account: app.account,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            page: app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.translationStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'translation/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'translation', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";


</style>
